<template>
  <onboarding-step :validate="validate">
    <template #heading>
      What kind of jobs are you interested in?
    </template>
    <template #help>
      You can edit your job priorities anytime after creating your personal report.
    </template>
    <template #content>
      <div class="grid gap-1 md:gap-2">
        <div
          v-for="job in jobs"
          :key="job.field"
          :class="[
            'h-full border rounded-lg bg-gray-100 dark:bg-gray-800 md:hover:text-orange group group-checked:bg-orange-100',
            user.report[job.field]
              ? 'bg-orange-50 border-orange-100 !text-orange'
              : '!text-blue dark:text-white border-transparent'
          ]"
        >
          <l-checkbox
            v-model="user.report[job.field]"
            class="label:w-full label:flex label:gap-3 label:items-baseline label:p-3 label:cursor-pointer shrink-0"
            :true-value="user.report[job.field] || Priority.MEDIUM"
            :false-value="Priority.NO"
          >
            <div>
              <div class="leading-none mb-1.5 flex items-center justify-between gap-3 font-medium">
                {{ job.title }}
              </div>
              <div class="text-sm md:text-base">
                {{ job.description }}
              </div>
            </div>
          </l-checkbox>
        </div>
      </div>
    </template>
    <template #footer>
      <podcast-promo class="lg:hidden"/>
    </template>
    <template #subcontent>
      <div class="flex flex-col gap-10">
        <img src="/images/illustration-sitting-4.svg" class="h-auto mx-auto">
        <podcast-promo/>
      </div>
    </template>
  </onboarding-step>
</template>

<script setup>
import LCheckbox from "@/components/inputs/LCheckbox.vue"
import OnboardingStep from "@/components/onboardings/OnboardingStep.vue"
import PodcastPromo from "@/components/PodcastPromo.vue"
import { Priority } from "@/models/Priority"
import { useJobs } from "@/composables/useJobs"

const user = defineModel({ type: Object, required: true })

const { jobs } = useJobs()

const validate = () => {
  for (const job in user.value.report) {
    if (user.value.report[job]) {
      return
    }
  }

  return "Please select at least one job type."
}
</script>
